<!-- <div class="generate-promocode-container">
    <div class="clearfix m-10 px-2 py-3">
      <button type="button" class="btn btn-secondary btn-lg">Generate Promo</button>
    </div>
    <mat-card class="p-2">
      <div class="generate-promocode-form-container">
        <form (ngSubmit)="onPromoCodeSubmit()" [formGroup]="generatePromoForm">
          <div class="form-inner  content-details-blk">
           
            <div class="row my-2">
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
                <h4 class="form-item-label" translate>
                  Product Code <span class="required">*</span>
                </h4>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
                <div class="form-item-input">
                  <mat-form-field appearance="outline">
                      <input
                        matInput
                        type="text"
                        formControlName="promoCode"
                        placeholder="Enter promoCode"
                       required
                      />
                    </mat-form-field>
                    <div *ngIf="f.promoCode.touched && f.promoCode.invalid">
                      <div *ngIf="f.promoCode.errors.required">
                        <mat-hint class="text-danger ms-2">
                          promoCode is required.</mat-hint
                        >
                      </div>
                    </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
                <h4 class="form-item-label" translate>
                  Product <span class="required">*</span>
                </h4>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
                <div class="form-item-input">
                  <mat-form-field appearance="outline">
                    <mat-select formControlName="product" required>
                      <mat-option >
                       IMTU
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div *ngIf="f.product.touched && f.product.invalid">
                    <div *ngIf="f.product.errors.required">
                      <mat-hint class="text-danger ms-2">
                        product is required.</mat-hint
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <div class="row my-2">
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
                <h4 class="form-item-label" translate>
                  {{'pages.Promocodehistory.Carrier' | translate }} <span class="required">*</span>
                </h4>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
                <div class="form-item-input">
                  <mat-form-field appearance="outline">
                    <mat-select formControlName="carrier" required>
                      <mat-option value="Aritel India">
                       Aritel India
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div *ngIf="f.carrier.touched && f.carrier.invalid">
                    <div *ngIf="f.carrier.errors.required">
                      <mat-hint class="text-danger ms-2">
                        carrier is required.</mat-hint
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
                <h4 class="form-item-label" translate>
                  Country <span class="required">*</span>
                </h4>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
                <div class="form-item-input">
                  <mat-form-field appearance="outline">
                    <mat-select formControlName="country" required>
                      <mat-option value="India"
                       >
                       India
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <div *ngIf="f.country.touched && f.country.invalid">
                    <div *ngIf="f.country.errors.required">
                      <mat-hint class="text-danger ms-2">
                        carrier is required.</mat-hint
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
            <div class="row my-2">
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
                <h4 class="form-item-label" translate>
                  Amount <span class="required">*</span>
                </h4>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
                  <div class="form-item-input">
                    <mat-form-field class="w-50" appearance="outline">
                      <mat-select formControlName="amount1" required>
                        <mat-option value="$">$10</mat-option>
                        <mat-option value="%">$20</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field class="w-50" appearance="outline">
                      <mat-select formControlName="amount2" required>
                        <mat-option value="$">$10</mat-option>
                        <mat-option value="%">%20</mat-option>
                      </mat-select>
                    </mat-form-field>
               
                  </div>
                </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
                <h4 class="form-item-label" translate>
                  Discount <span class="required">*</span>
                </h4>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
                <div class="form-item-input">
                  <mat-form-field class="w-50" appearance="outline">
                    <mat-select formControlName="discount" required>
                      <mat-option value="$">
                      $
                      </mat-option>
                      <mat-option value="%">
                          %
                          </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field class="w-50" appearance="outline">
                    <input
                      matInput
                      type="text"
                      formControlName="discountValue"
                     required
                    />
                  </mat-form-field>
                </div>
                <span  class="material-icons pt-2 discounticon">
                  info
                  </span>
                <span class="discounticon">Discount to be entered in % or $</span>
              </div>
            </div>
  
            <div class="row my-2">
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
                <h4 class="form-item-label" translate>
                  Validity <span class="required">*</span>
                </h4>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
                  <div class="form-item-input">
                    <mat-form-field class="w-50" appearance="outline">
                      <input matInput [matDatepicker]="picker" formControlName="fromDate" placeholder="Start date" required>
                      <mat-datepicker-toggle matSuffix [for]="picker" >
                        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                    <mat-form-field class="w-50" appearance="outline">
                      <input matInput [matDatepicker]="picker1" formControlName="toDate" placeholder="End date" required>
                      <mat-datepicker-toggle matSuffix [for]="picker1" >
                        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
                      </mat-datepicker-toggle>
                      <mat-datepicker #picker1></mat-datepicker>
                    </mat-form-field>
                  </div>
                </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
                <h4 class="form-item-label" translate>
                  Redeem Limit<span class="required">*</span>
                </h4>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
                <div class="form-item-input">
                  <mat-form-field class="" appearance="outline">
                      <input
                      matInput
                      type="text"
                      required
                      placeholder="Enter Currency"
                      formControlName="redeemLimit"
                      required
                    />
                    </mat-form-field>
                </div>
              </div>
            </div>
  
            <div class="row my-2">
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
                <h4 class="form-item-label" translate>
                  Description  <span class="required">*</span>
                </h4>
              </div>
              <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12 align-self-center">
                <div class="form-item-input">
                  <mat-form-field appearance="outline">
                      <textarea
                      matInput
                      required
                      formControlName="description"
                      placeholder="Description"
                      class="text-area"
                    >
                    </textarea>
                  </mat-form-field>
                </div>
              </div>
             
            
            </div>
  
    
  
            
          </div>
          <div class="form-footer">
            <ul class="list-inline text-center">
              <li class="list-inline-item">
                <button
                  mat-raised-button
                  [disabled]="!generatePromoForm.valid"
                  color="primary"
                  type="submit"
                  class="rounded-0"
                >
                  <span translate class="translate">Generate & Send</span>
                </button>
              </li>
              <li class="list-inline-item">
                <button
                  mat-stroked-button
                  [disabled]="!generatePromoForm.valid"
                  color="primary"
                  type="button"
                  class="rounded-0"
                  (click)="onCancel()"
                >
                  <span translate class="translate">Save & Continue Later</span>
                </button>
              </li>
              <li class="list-inline-item"></li>
            </ul>
          </div>
        </form>
      </div>
    </mat-card>



</div> -->
<mat-card> hadfskjglfh </mat-card>
